import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  Button,
  CircularProgress,
} from "@mui/material";

const DeleteConfirmationDialog = ({
  deleteModalOpen,
  handleNo,
  handleYes,
  itemToDelete,
  title,
  message,
  isDeleting,
}: {
  deleteModalOpen: boolean;
  handleNo: () => void;
  handleYes: (log: any) => void;
  itemToDelete: any;
  title: string;
  message: string;
  isDeleting?: boolean;
}) => {
  return (
    <Dialog open={deleteModalOpen} onClose={handleNo} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ color: "error.main", fontWeight: 600 }}>
        {title}
      </DialogTitle>
      <DialogContent sx={{ pb: 3, pt: 2 }}>
        <Typography variant="body2" sx={{ mb: 3 }}>
          {message}
        </Typography>
        <Box display="flex" justifyContent="space-between" gap={2} mt={2}>
          <Button
            variant="outlined"
            color="inherit"
            onClick={handleNo}
            sx={{ px: 2, py: 0.5, fontSize: "0.8rem" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => handleYes(itemToDelete!)}
            sx={{ px: 2, py: 0.5, fontSize: "0.8rem" }}
          >
            {isDeleting ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              "Delete"
            )}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
